export default {
  searchUserPlaceholder: "Nom ou adresse e-mail",
  searchUsersMatching: "0 utilisateur correspond à votre recherche. Vérifiez que vous avez bien orthographié, peut-être pouvez-vous ajouter un nom de famille ? | 1 utilisateur correspond à votre recherche. | {userCount} utilisateurs correspondent à votre recherche.",
  selectAll: "Sélectionnez toute l'équipe de chasse",
  deselectAll: "Désélectionner toute l'équipe de chasse"
}
